<template>
  <div>
    <vue-element-loading :active="visible" :is-full-screen="true" />
    <va-card class="overflow-auto flex md12 sm6 xs12">
      <div>
        <div class="row">
          <div class="flex md12 sm6 xs12">
            <h4 style="font-size: 24px !important" class="card-title mx-2">
              Identification Details &nbsp;
              <span v-if="data.status == 'read' || data.status == 'unread'">
                <button
                  @click="reply"
                  v-scroll-to="{ element: '#reply', duration: 2000 }"
                  type="button"
                  class="btn btn-light pl-2"
                  style
                >
                  <i class="fa fa-reply"></i>&nbsp;Reply
                </button>
              </span>
              <span v-else-if="data.status == 'replied'">
                <button
                  @click="replied"
                  v-scroll-to="{ element: '#view', duration: 2000 }"
                  type="button"
                  class="btn btn-light pl-2"
                  style
                >
                  <i class="fa fa-reply"></i>&nbsp;View Reply
                </button>
              </span>
            </h4>
          </div>
        </div>
        <div v-if="stat">
          <table class="table table-white flex md10">
            <thead>
              <tr></tr>
            </thead>
            <tbody class="row">
              <tr
                class="col-md-6"
                style="font-style: italic !important"
                v-if="user.fullName"
              >
                <th scope="col">Name</th>
                <td>{{ user.fullName }}</td>
              </tr>
              <tr class="col-md-6" v-if="user.email">
                <th scope="col">Email</th>
                <td>{{ user.email }}</td>
              </tr>
              <tr class="col-md-6" v-if="user.phone">
                <th scope="col">Phone</th>
                <td>{{ user.phone }}</td>
              </tr>
              <tr class="col-md-6" v-if="user.address">
                <th scope="col">Address</th>
                <td>{{ user.address }},{{ user.state }}</td>
              </tr>
            </tbody>
          </table>
          <div class="pl-3">
            <div class="flex md12 sm6 xs12"><b>Identification features</b></div>
            <p>{{ data.comments }}</p>
          </div>
          
            <div class="col-md-12 row">
              <div class="card-body text-secondary col-md-12">
                <div
                  v-if="photos != null && photos.length > 0"
                  style="
                    overflow-x: auto !important;
                    overflow-y: hidden !important;
                  "
                >
                  <h6>Photos:</h6>
                  <div v-viewer style="display: flex">
                    <div
                      v-for="image in images"
                      :key="image.key"
                      style="width:200px;height200px;max-height:200px; "
                      class="col-md-3"
                    >
                      <img
                        :src="image.src"
                        class="image"
                        style="
                          width: 100%;
                          height: 100%;
                          object-fit: cover;
                          max-width: 250px;
                        "
                        :key="image.src"
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div
                v-if="videos != null && videos.length > 0 && data._id != null"
                class="col-md-12 row"
                style="
                  padding-top: 30px;
                  padding-left: 10px;
                  padding-right: 10px;
                "
              >
                <h6>
                  Videos(Please double click to view video in fullscreen):
                </h6>
                <div class="card-body text-secondary">
                  <div style="display: flex">
                    <div
                      v-for="vid in videos"
                      :key="vid"
                      class="flex md6 sm12 xs12"
                    >
                      <video
                        class="pr-5"
                        width="100%"
                        height="300px"
                        style="object-fit: cover"
                        controls
                      >
                        <source
                          :src="'http://13.232.13.116/file/get/' + vid"
                          type="video/mp4"
                        />
                      </video>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              id="view"
              v-if="data.status == 'replied'"
              class="flex md12 sm6 xs12 pl-3"
            >
              <div>
                <div style="font-size: 18 px" class="flex md6 sm6 xs12">
                  Reply Message
                </div>
                <div class="pt-2">
                  <h6 class="text-justify">{{ data.reply }}</h6>
                </div>
              </div>
            </div>
          
        </div>
        <br>
        <div id="reply" v-if="show" class="flex md11 sm6 xs12 card  shadow-sm p-3 mb-5 bg-white rounded">
          <div class="row">
            <div class="flex md6 sm6 xs12"></div>
          </div>
          <b-form @submit="onSubmit">
            <b-row class="mt-2 pl-4">
              <b-col md="8">
                <h6>Please pass your comments (if any)</h6>
                <b-form-textarea
                  v-model="replyMsg"
                  id="textarea-rows"
                  rows="3"
                  max-rows="20"
                  required
                  placeholder="Please enter the reply..."
                ></b-form-textarea>
              </b-col>
              <b-col md="4">
                <!-- <b-form-group label="Question *">
                      <b-form-input list="records" v-model="species" placeholder="Select from suggestions or Type a new question"></b-form-input>
                      <datalist id="records">
                        <option v-for="(item,i) in records" :key="i">{{item.ScientifiName}}</option>
                      </datalist>
                      
                      <template slot="description" v-if="validation.firstError('fieldlabel')">
                        <span style="color:red;">{{validation.firstError('fieldlabel')}}</span>
                      </template>
                    </b-form-group> -->
                    <h6>
                      Please Select the Species
                    </h6>
                <select
                  class="pt-2 pb-2"
                  style="width: 100% !important"
                  v-model="species"
                >
                  <option selected disabled>Please Select Species</option>
                  <option
                    class="text-capitalize"
                    v-for="item in records"
                    :value="item._id"
                    :key="item._id"
                    selected="Pleae"
                  >
                    {{ item.commonName }} ({{ item.scientificName }})
                  </option>
                </select>
              </b-col>
            </b-row>

            <div class="flex md12 sm6 xs12 pt-4 pb-4" align="right">
              <b-button type="submit" variant="success">Submit</b-button>
            </div>
          </b-form>
        </div>
      </div>
      <div v-if="!stat">No Data Found!!</div>
    </va-card>
  </div>
</template>

<script>
import axios from "axios";
import VueElementLoading from "vue-element-loading";
export default {
  components: {
    VueElementLoading,
  },
  props: ["id"],
  data() {
    return {
      e: "",
      visible: false,
      data: [],
      remark: "",
      show: false,
      show1: false,
      replyMsg: "",
      msg: "",
      status: "",
      photos: [],
      stat: false,
      videos: [],
      user: [],
      records: [],
      species: null,
    };
  },
  mounted: function () {
    this.getDetails();
    this.digitalGuideList();
  },
  methods: {
    reply() {
      this.show = true;
    },
    replied() {
      this.show1 = true;
    },
    digitalGuideList() {
      this.visible = true;
      var data1 = {};
      if (this.classificationId !== "") {
        data1["classificationId"] = this.classificationId;
      }
      if (this.conservationStatusId !== "") {
        data1["conservationStatusId"] = this.conservationStatusId;
      }
      if (this.citesId !== "") {
        data1["citesId"] = this.citesId;
      }
      if (this.wlpaId !== "") {
        data1["wlpaId"] = this.wlpaId;
      }
      axios({
        method: "POST",
        url: "/digitalguide/list",
        data: data1,
        headers: {
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          if (response.data.status === true) {
            this.records = response.data.data;
            //      for (var i = 0; i < this.records.length; i++) {
            //        this.

            // }
            this.visible = false;
          } else if (response.data.status === false) {
            this.visible = false;
          }
        })
        .catch((e) => {
          console.log(e);
          this.visible = false;
          // this.errors.push(e)
          this.msg = "failed";
        });
    },
    getDetails() {
      this.visible = true;
      axios({
        method: "POST",
        url: "/identification/view/details/" + this.id,
        headers: {
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          // console.log(response.data.data)
          if (response.data.status === true) {
            this.user = response.data.data.uid;
            this.data = response.data.data;
            this.stat = response.data.status;
            this.status = response.data.data.status;
            this.photos = response.data.data.photos;
            this.videos = response.data.data.videos;
            var arlen = [];
            arlen = this.photos;

            var temp = [];
            for (var pic = 0; pic < arlen.length; pic++) {
              var ty = {
                src: "http://13.232.13.116/document/get/" + arlen[pic],
                thumb: "http://13.232.13.116/document/get/" + arlen[pic],
              };
              temp.push(ty);
            }
            this.images = temp;
            var dt = this.data.create_date;
            dt = new Date(dt);
            dt = dt.toString();
            dt = dt.slice(0, 15);
            this.data.create_date = dt;
          } else {
          }
          this.visible = false;
        })
        .catch((e) => {
          console.log(e);
          this.visible = false;
          this.errors.push(e);
          this.msg = "failed";
        });
    },
    onSubmit(evt) {
      this.visible = true;
      var data = {};
      data["id"] = this.id;
      data["replyMsg"] = this.replyMsg;
      data["species"] = this.species;
      console.log(this.data);
      evt.preventDefault();
      axios({
        method: "POST",
        url: "/identification/reply",
        headers: {
          token: localStorage.getItem("token"),
        },
        data: data,
      })
        .then((response) => {
          this.msg = response.data.msg;
          this.visible = "false";
          this.$dlg.alert(
            this.msg,
            () => {
              this.$router.push("/guidelist");
            },
            { messageType: "success" }
          );
        })
        .catch((e) => {
          console.log(e);
        });
    },
  },
};
</script>
<style >
/* .modal-footer {
  display: none !important;
} */
</style>
